import { Modal } from 'react-bootstrap';
import styled from 'styled-components';

export const Container = styled.div``;

export const LoadingContracts = styled.span`
  font-size: 18px;
  font-weight: bold;
`;

export const ContractNotFound = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-content: center;
  max-width: 80%;
  margin-top: 32px;

  button {
    margin-left: 16px;
  }

  @media (max-width: 600px) {
    flex-direction: column;
    width: 100%;
    display: flex;
    align-items: inherit;
    max-width: unset;

    button {
      margin-left: unset;
      margin-top: 16px;
    }
  }
`;

export const ContractNotFoundText = styled.span`
  font-size: 20px;
  font-weight: 500;
  span {
    display: block;
  }
`;

export const TextBold = styled(ContractNotFoundText)`
  font-size: 21px;
  font-weight: 700;
  display: inline-block !important;
  margin-left: 8px;
`;

export const ButtonRequestContract = styled.button`
  padding: 8px 16px;
  border-radius: 4px;
  min-width: 172px;
  font-weight: bold;

  border: 2px solid #000fff;
  background: #000fff;
  color: #fff;
  cursor: pointer;

  border-radius: 4px;
  min-width: 156px;

  &:hover {
    filter: opacity(0.6);
  }
`;

export const ModalStyle = styled(Modal)`
  .modal-content {
    max-width: 648px;
    width: auto;
    border-radius: 10px;
  }
  .modal-dialog-centered {
    max-width: 648px !important;
    place-content: center;
  }
`;

export const ModalContainer = styled.div`
  padding: 28px 28px 28px 28px;
  max-width: 670px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 18px;
    width: 100%;
  }
`;

export const ModalHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin-bottom: 0 !important;

  div {
    display: flex;
    place-content: space-between;
    align-items: center;
    h2 {
      margin: 0;
      color: #808495;
      font-size: 18px;
      font-weight: 400;
    }
  }

  svg {
    flex-shrink: 0;

    &:first-child {
      margin-right: 10px;
    }

    &:last-child {
      color: ${({ theme }) => theme.colors.darkBlue};
      cursor: pointer;
      margin-left: 10px;
    }
  }

  margin-bottom: 16px;
`;
